import { wijzneusApi } from "./wijzneus-api";
const getDashboardData = () => {
    return wijzneusApi.get(`dashboard`);
};
const DashboardApi = {
    getDashboardData
};
export default DashboardApi;
